<template>
  <svg
    role="presentation"
    width="32"
    height="32"
    class="icon"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 29.3333C23.3638 29.3333 29.3334 23.3638 29.3334 16C29.3334 8.63616 23.3638 2.66663 16 2.66663C8.63622 2.66663 2.66669 8.63616 2.66669 16C2.66669 23.3638 8.63622 29.3333 16 29.3333Z"
      class="cls-1"
    />
    <path d="M16 21.3333V16" class="cls-1" />
    <path d="M16 10.6666H16.0133" class="cls-1" />
  </svg>
</template>

<script>
export default {
  name: 'InfoIcon'
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.icon {
  height: var(--_icon-height, var(--icon-size, 3.2rem));
  width: var(--_icon-width, var(--icon-size, 3.2rem));
  fill: none;
}

.cls-1 {
  fill: none;
  stroke: var(--_icon-stroke, var(--zenith-black));
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
